import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'

let inited = false

export function initFontAwesome(): void {
  if (inited) return

  // TODO: https://statscore.atlassian.net/browse/COLL-815
  /**
   * `fas` includes all icons from `@fortawesome/free-solid-svg-icons`.
   *
   * Note: Importing the entire style can significantly increase your bundle size.
   * Import only the icons you need whenever possible.
   *
   * For more information, see:
   * https://docs.fontawesome.com/web/use-with/vue/add-icons#several-icon-in-different-styles
   */
  library.add(fas)
  inited = true
}
